module.exports = __webpack_public_path__ + "img/img5.2c6e0408.svg";